import { useRouter } from "next/router";

export const CONTENT_APP_PARAM = "contentapp";
export const useRouterCaller = () => {
    const router = useRouter();

    return {
        isCallerContentApp: router.query.caller === CONTENT_APP_PARAM,
    };
};
